import React, { PropTypes } from 'react';
import { WithContext as ReactTags } from 'vendor/react-tag-input';
import './Tags.scss'

class Tags extends React.Component {
  constructor(props) {
    super(props);

  }


  render() {

    const { value, onChange, label, tagContainerClass, className, handleInputFocus,
      placeholder, suggestions, tags, handleAddition, handleDelete, handleInputBlur } = this.props;
    return (
      <div className={'row ' + className}>
        <div className='col-xs-3'>
          <span className='tags-label'>{label}</span>
        </div>
        <div className='col-xs-9'>
          <ReactTags
            classNames={{
              tags: tagContainerClass + ' tagsClass',
              tagInput: tags.length > 0 ? 'tagInputClass adjusted-width' : 'tagInputClass',
              tagInputField: 'tagInputFieldClass',
              selected: 'selectedClass',
              tag: 'tagClass',
              remove: 'removeClass',
              suggestions: 'suggestionsClass',
              activeSuggestion: 'activeSuggestionClass'
            }}
            inline
            suggestions={suggestions}
            placeholder={tags.length > 0 ? '' : placeholder}
            tags={tags}
            handleDelete={handleDelete}
            handleAddition={handleAddition}
            handleInputFocus={handleInputFocus}
            handleInputBlur={handleInputBlur}
            autofocus={false}
           />
        </div>
      </div>

    );
  }
}

export default Tags;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/Tags/index.js